import Vue from "vue";
import gridbase from "../../components/gridComponentBase.js";
import moment from "moment";
import helpers from "../../shared/fleetbox-helpers";
import cellDetailTemplate from "./cellDetailTemplate.vue";
import { bus } from "../../main";
import { mapGetters } from "vuex";

export default {
	extends: gridbase,
	components: {
		cellDetailTemplate
	},
	props: {
		data: Array,
		totalTripsCount: Number,
		configs: Array,
		startDate: Object,
		endDate: Object,
		codeFilters: Array,
		codeFilterSelected: Array,
		vehicleItemsFilter: Array,
		vehicleSelectedFilter: Array,
		driverItemsFilter: Array,
		driversSelectedFilter: Array,
		filtersByQuery: Boolean,
		vehicleIdFilterField: String
	},
	data: function() {
		return {
			cellTemplateInstance: cellDetailTemplate,
			dataReady: false,
			expandField: "expanded",
			columnsToShow: [],
			columns: [
				{
					field: "number_plate",
					title: "targa",
					configId: "numberPlate",
					width: "100",
					headerCell: "myLicensePlateHeaderTemplate",
					format: "",
					filterable: true
				},
				{
					field: "vehicle_code",
					title: "Codice",
					configId: "vehicleCode",
					width: "120",
					headerCell: "myLicensePlateHeaderTemplate",
					format: "",
					filterable: true
				},
				{
					field: "driver_name",
					title: "conducente",
					configId: "driverName",
					width: "205",
					headerCell: "myDriverHeaderTemplate",
					format: "",
					filterable: true
				},
				{
					field: "first_trip_start_date",
					title: "data part.",
					configId: "departureDate",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "first_trip_start_time",
					title: "ora part.",
					configId: "departureTime",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "last_trip_end_date",
					title: "data arr.",
					configId: "arrivalDate",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "last_trip_end_time",
					title: "ora arr.",
					configId: "arrivalTime",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "trip_time",
					title: "tempo viaggio",
					configId: "tripTime",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false
				},
				{
					field: "drive_time",
					title: "tempo guida",
					configId: "driveTime",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "",

					filterable: false
				},
				{
					field: "idle_time",
					title: "tempo inattività",
					configId: "idleTime",
					width: "160",
					headerCell: "myHeaderTemplate",
					format: "",

					filterable: false
				},
				{
					field: "first_start_location_display_name",
					title: "luogo iniziale",
					configId: "startLocation",
					width: "250",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "myFirstPositionDisplayName",
					filterable: false
				},
				{
					field: "last_end_location_display_name",
					title: "luogo iniziale",
					configId: "endLocation",
					width: "250",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "myLastPositionDisplayName",
					filterable: false
				},
				// {
				// 	field: "speedometer_initial_value",
				// 	title: "km inizio",
				// 	configId: "speedometerInitialValue",
				// 	width: "100",
				// 	headerCell: "myHeaderTemplate",
				// 	format: "",

				// 	filterable: false
				// },
				// {
				// 	field: "speedometer_final_value",
				// 	title: "km fine",
				// 	configId: "speedometerFinalValue",
				// 	width: "100",
				// 	headerCell: "myHeaderTemplate",
				// 	format: "",

				// 	filterable: false
				// },
				{
					field: "gps_trip_km",
					title: "km gps",
					configId: "gpsTripKm",
					width: "160",
					cell: "myCellTemplate",
					format: "numeric",
					headerCell: "myHeaderTemplate",
					filterable: false
				},
				{
					field: "path_trip_km",
					title: "km path",
					configId: "pathTripKm",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "interpolated_trip_km",
					title: "km interpolati",
					configId: "interpolatedTripKm",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "interpolated_trip_lt",
					title: "Litri Viaggio",
					configId: "interpolatedTripLt",
					width: "150",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "avg_fuel_consumption",
					title: "consumo medio",
					configId: "avgFuelConsumption",
					width: "225",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "avg_co2_emission",
					title: "CO<sub>2</sub> media",
					configId: "avgCo2Emitted",
					width: "155",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "co2_emitted",
					title: "CO<sub>2</sub> emessa",
					configId: "co2Emitted",
					width: "150",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "max_speed",
					title: "velocità massima",
					configId: "maxSpeed",
					width: "215",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "avg_speed",
					title: "velocità media",
					configId: "avgSpeed",
					width: "195",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				// {
				// 	field: "last_odometer_km_value",
				// 	title: "Km Totali",
				// 	configId: "lastOdometerKmValue",
				// 	width: "100",
				// 	headerCell: "myHeaderTemplate",
				// 	format: "",

				// 	filterable: false
				// },
				// {
				// 	field: "last_odometer_lt_value",
				// 	title: "Litri Totali",
				// 	configId: "lastOdometerLtValue",
				// 	width: "100",
				// 	headerCell: "myHeaderTemplate",
				// 	format: "",

				// 	filterable: false
				// },
				{
					field: "avg_brand_fuel_consumption",
					title: "Consumo medio costruttore",
					configId: "avgBrandFuelConsumption",
					width: "330",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "fuel_consumption_km_lt",
					title: "Consumo KM/LT",
					configId: "fuelConsumptionKmLt",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "avg_training_fuel_consumption",
					title: "Cnsumo Medio Formazione",
					configId: "avgTrainingFuelConsumption",
					width: "265",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "brand_total_lt",
					title: "Consumo Litri (costruttore)",
					configId: "brandTotalLt",
					width: "265",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false
				},
				{
					field: "pois",
					title: "",
					width: "45",
					headerCell: "myHeaderImagePoisTemplate",
					sortable: false,
					filterable: false,
					cell: "myPoisCellTemplate",
					format: "",
					configByPass: true,
					order: 4
				},
				{
					field: "alarms",
					title: "",
					width: "45",
					headerCell: "myHeaderImageAlarmsTemplate",
					sortable: false,
					filterable: false,
					cell: "myAlarmsCellTemplate",
					format: "",
					configByPass: true,
					order: 3
				},
				{
					field: "diagnostic",
					title: "",
					width: "45",
					headerCell: "myHeaderImageDiagnosisTemplate",
					sortable: false,
					filterable: false,
					cell: "myDiagnosisCellTemplate",
					format: "",
					configByPass: true,
					order: 2,
					permission: "TRIPS_DIAGNOSTIC_DATA"
				},
				// {
				// 	field: "alarms",
				// 	title: "Diagnostica / Allarmi",
				// 	width: "190",
				// 	headerCell: "myHeaderTemplate",
				// 	sortable: false,
				// 	cell: "myDiagnosticAlarmsCellTemplate",
				// 	format: "",
				// 	configByPass: true
				// },
				// {
				// 	field: "visible",
				// 	title: "Mappa",
				// 	width: "90",
				// 	headerCell: "myHeaderSwitchTemplate",
				// 	sortable: false,
				// 	cell: "myVisibilityCellTemplate",
				// 	format: "booleanSwitch",
				// 	configByPass: true
				// },
				{
					field: "visible",
					title: "",
					width: "45",
					headerCell: "myHeaderImageMapsTemplate",
					sortable: false,
					cell: "myVisibilityCellTemplate",
					format: "booleanSwitch",
					configByPass: true,
					order: 1
				},
				{
					field: "status",
					title: "",
					width: "45",
					headerCell: "myHeaderTemplate",
					sortable: false,
					filterable: false,
					cell: "myStatusCellTemplate",
					configByPass: true,
					order: 0
				}
			],

			debug: false,
			jsonRowDataModal: false,
			jsonRowDataModalText: "",
			showCopyMessageSuccessResult: false,
			showCopyMessageErrorResult: false,

			hasColumnsSelection: true,
			popoverShow: false,
			firstLoad: true,
			updated: 0,
			renderColumnTotalWidth: 0,

			timeoutRefreshTable: null,
			index: 0
			//isAllDetailExpanded: false
		};
	},

	created() {
		var self = this;

		if (self.$route.query.debug) {
			self.debug = self.$route.query.debug == "true";
		}

		if (this.vehicleIdFilterField == "code") {
			let col = this.columns.find(function(item) {
				return item.field == "number_plate";
			});

			if (col) col.filterable = false;
		}
		else {
			let col = this.columns.find(function(item) {
				return item.field == "vehicle_code";
			});

			if (col) col.filterable = false;
		}

		this.hasSelectedMode = true;
		this.query.pageSize = 25;
		this.take = 25;
		this.items = this.data;
		this.total = this.totalTripsCount;
		bus.$on("alarm-marker-click", self.markerClickHandler.bind(self));
		bus.$on("trip-detail-on-selection-row", self.tripDetailOnSelectionRow.bind(self));

		bus.$on("on-trips-filters-change", self.onTripsFiltersChange.bind(self));
	},
	beforeDestroy() {
		bus.$off("alarm-marker-click");
		bus.$off("trip-detail-on-selection-row");
		bus.$off("on-trips-filters-change");
	},
	watch: {
		totalTripsCount: {
			handler() {
				var self = this;
				this.total = this.totalTripsCount;

				setTimeout(function() {
					if (self.$refs && self.$refs.gridTrips) {
						var childrens = self.$refs.gridTrips.$children;
						var pagerComponent = childrens.find(item => {
							return item.$el.className.indexOf("pager") >= 0;
						});
						if (pagerComponent) {
							var pagerInfo = $(pagerComponent.$el.querySelector(".k-pager-info"));
							if (pagerInfo.html().lastIndexOf("<") >= 0) {
								//pagerInfo.html(pagerInfo.html().substring(0, pagerInfo.html().lastIndexOf("<")));
								return;
							}
							if (pagerInfo.length > 0) {
								pagerInfo.append(`<br /> (*) - ${self.settings.commonLabels.key_invalid_path_trip}`);
							}
						}
					}
				}, 1);
			}
		},
		data: {
			handler() {
				var self = this;
				this.items = this.data;

				//pager custom
				// setTimeout(function() {
				// 	if (self.$refs && self.$refs.gridTrips) {
				// 		var childrens = self.$refs.gridTrips.$children;
				// 		var pagerComponent = childrens.find(item => {
				// 			return item.$el.className.indexOf("pager") >= 0;
				// 		});
				// 		if (pagerComponent) {
				// 			var pagerInfo = $(pagerComponent.$el.querySelector(".k-pager-info"));
				// 			if (pagerInfo.html().lastIndexOf("<") >= 0) {
				// 				pagerInfo.html(pagerInfo.html().substring(0, pagerInfo.html().lastIndexOf("<")));
				// 			}
				// 			if (pagerInfo.length > 0) {
				// 				pagerInfo.append(`<br /> (*) - ${self.settings.commonLabels.key_invalid_path_trip}`);
				// 			}
				// 		}
				// 	}
				// }, 5000);
				//$(self.$refs.gridTrips.$children[2].$el.querySelector(".k-pager-info")).append(`<br /> (*) - ${this.settings.commonLabels.key_invalid_path_trip}`)
			},
			deep: true
		},
		configs: {
			handler() {
				var self = this;
				clearTimeout(this.timeoutRefreshTable);
				var refreshColumns = function() {
					self.timeoutRefreshTable = setTimeout(function() {
						if (self.configs && self.configs.length > 0) {
							var orderedConfigColumn = self._.orderBy(self.configs, "order", "asc");
							var index = 4;
							orderedConfigColumn.forEach(column => {
								var defColumn = self.columns.find(function(f) {
									return f.configId === column.field;
								});

								var indexOfColumnShown = self.columnsToShow.findIndex(function(item) {
									return item.configId == column.field;
								});

								if (defColumn && column.enabled) {
									// if (column.label && column.label.toLowerCase().indexOf("co2") >= 0) {
									// 	//column.label = column.label.toLowerCase().replace("co2", "co<sub>2</sub>")
									// }
									defColumn.title = column.label;

									if (indexOfColumnShown < 0) {
										//self.columnsToShow.push(defColumn);
										self.columnsToShow.splice(index, 0, defColumn);
									}

									index++;
								} else {
									if (indexOfColumnShown >= 0) {
										self.columnsToShow.splice(indexOfColumnShown, 1);
									}
								}
							});

							if (self.firstLoad) {
								var columnsByPassConfig = self._.filter(self.columns, function(item) {
									return item.configByPass && (!item.permission || self.scopes.some(colp => {
										return item.permission == colp;
									}));
								});

								for (var i = 0; i < columnsByPassConfig.length; i++) {
									self.columnsToShow.unshift(columnsByPassConfig[i]);
								}
							}

							self.dataReady = true;

							if (self.firstLoad) {
								self.getData();

								self.columnsToShow.forEach(function(col) {
									self.renderColumnTotalWidth += col.width;
								});
							} else {
								for (var i = 0; i < self.data.length; i++) {
									var item = self.data[i];
									if (item && item.expanded) {
										Vue.set(item, self.expandField, false);
									}
								}

								var newTotalWidth = 0;

								self.columnsToShow.forEach(function(col) {
									newTotalWidth += col.width;
								});

								if (newTotalWidth < self.renderColumnTotalWidth) {
									self.updated++;
									self.renderColumnTotalWidth = newTotalWidth;
								}
							}

							self.firstLoad = false;
						}
					}, 500);
				};
				refreshColumns();
			},
			deep: true
		}
	},
	/* metodi */
	methods: {
		onTripsFiltersChange() {
			this.skip = 0;
			this.take = 25;
		},
		tripDetailOnSelectionRow(dataItem) {
			var findMasterDataItem = this.items.findIndex(masteritem => {
				if (masteritem.detailRow) {
					return (
						masteritem.detailRow.findIndex(item => {
							return item.id == dataItem.id;
						}) >= 0
					);
				}

				return -1;
			});

			if (findMasterDataItem >= 0) {
				this.selectRow(this.items[findMasterDataItem]);
			}
		},
		filterHandler(e) {
			if (e.filterable) {
				if (e.filterType == "daterange") {
					this.$emit("filter-daterange-change", {
						startDate: e.startDateHeader,
						endDate: e.endDateHeader,
						type: "date",
						reset: false
					});
				}
				if (e.filterType == "timerange") {
					this.$emit("filter-daterange-change", {
						startTime: e.startTimeHeader,
						endTime: e.endTimeHeader,
						type: "time",
						reset: false
					});
				}

				this.$emit("trips-get-data", {
					sort: this.query.sort,
					page: this.query.page,
					pageSize: this.query.pageSize
				});
			}
		},
		removeFilterHandler(e) {
			if (e.filterable) {
				if (e.field == "number_plate" || e.field == "vehicle_code") {
					this.vehicleSelectedFilter.splice(0, this.vehicleSelectedFilter.length);
				}
				if (e.field == "driver_name") {
					this.driversSelectedFilter.splice(0, this.driversSelectedFilter.length);
				}
				if (e.field == "first_trip_start_date" || e.field == "first_trip_start_time" || e.field == "last_trip_end_date" || e.field == "last_trip_end_time") {
					this.$emit("filter-daterange-change", {
						startDate: null,
						endDate: null,
						type: null,
						reset: true
					});
				}
				this.$emit("trips-get-data", {
					sort: this.query.sort,
					page: this.query.page,
					pageSize: this.query.pageSize
				});
			}
		},
		saveColumnsConfigruation() {
			this.$emit("save-columns-configuration");
			this.onCloseColumnsConfigPopover();
		},
		onCloseColumnsConfigPopover() {
			this.popoverShow = false;
		},
		showJsonDataModal(jsonData) {
			this.showCopyMessageSuccessResult = false;
			this.showCopyMessageErrorResult = false;
			this.jsonRowDataModalText = jsonData;

			this.$copyText(jsonData);
			this.jsonRowDataModal = true;
		},
		copyJsonRowData() {
			this.showCopyMessageSuccessResult = true;
		},
		expandChange(event) {
			this.selectRow(event.dataItem);
			Vue.set(event.dataItem, event.target.$props.expandField, event.value);
		},
		sortChangeHandler: function(e) {
			this.query.sort = e.sort;
			this.$emit("trips-get-data", {
				sort: this.query.sort,
				page: this.query.page,
				pageSize: this.query.pageSize
			});
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			// this.$emit("trips-get-data", {
			// 	sort: this.query.sort,
			// 	page: this.query.page,
			// 	pageSize: this.query.pageSize
			// });
		},
		onHeaderVisibleChange(visibility) {
			for (var i = 0; i < this.data.length; i++) {
				var item = this.data[i];
				if (item && this._.isNull(item.visible) === false && item.visible != visibility) {
					item.visibility = visibility;
					item.visible = visibility;
					if (!item.expanded) {
						Vue.set(item, this.expandField, true);
					}
				}
			}

			bus.$emit("on-trips-master-visibility-item-change");
		},
		onHeaderColExpItemChange() {
			var expand = !this.isAllDetailExpanded;

			for (var i = 0; i < this.data.length; i++) {
				var item = this.data[i];
				Vue.set(item, this.expandField, expand);
			}

			bus.$emit("on-trips-master-visibility-item-change");
		},
		onMasterRowClick(e) {
			this.selectRow(e.dataItem);
			if (e.dataItem.visible == false) {
				if (!e.dataItem.expanded) {
					Vue.set(e.dataItem, this.expandField, true);
				}
			}
		},
		booleanSwitchChange(e) {
			e.visible = !e.visibility;
			if (!e.expanded) {
				Vue.set(e, this.expandField, true);
			}

			this.selectRow(e);

			bus.$emit(`on-trip-master-row-visibility-item-change-${e.number_plate}`);
		},
		markerClickHandler(e) {
			if (e && e.marker) {
				var itemToSelect = this._.find(this.items, function(x) {
					return x.trip_id === e.marker.id;
				});

				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		getData() {
			this.$emit("trips-get-data", {
				sort: this.query.sort,
				page: this.query.page,
				pageSize: this.query.pageSize
			});
		},
		getDataFromCache() {
			this.$emit("alarms-get-cache-data");
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position && current_position.lat && current_position.lon) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position[tc], tc);
			}
			return null;
		}
	},
	computed: {
		...mapGetters(["settings", "scopes"]),
		gridDataItems() {
			var itemsToShow = this.items.slice(this.skip, this.take + this.skip);
			if (itemsToShow && itemsToShow.length) {
				bus.$emit("set-address-to", itemsToShow);
			}
			return itemsToShow;
		},
		totalCountHt() {
			return this.items.length;
		},
		vehiclesFilter() {
			return this.vehicleItemsFilter.map(function(item) {
				return {
					id: item.id,
					value: item.number_plate
				};
			});
		},
		driversFilter() {
			return this.driverItemsFilter.map(function(item) {
				return {
					id: item.id,
					value: `${item.surname} ${item.name}`
				};
			});
		},
		allAreShown() {
			var self = this;
			if (this.data && this.data.length > 0) {
				var filtersData = this.data.filter(function(item) {
					return self._.isNull(item.visible) === false;
				});

				if (filtersData.length > 0) {
					return filtersData.every(function(item) {
						return item.visible === true;
					});
				}

				return false;
			}

			return false;
		},
		isAllDetailExpanded() {
			var existsOneExpanded =
				this.data.findIndex(item => {
					return item.expanded == true;
				}) >= 0;

			return existsOneExpanded;
		}
	}
};
